document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.brand-logo-slider');
  const sliderTrack = document.querySelector('.slider-track');
  const slides = Array.from(sliderTrack.children);
  let autoSlideInterval;
  let currentTranslateX = 0;
  
  // Scroll speed
  const scrollSpeed = 1; // Speed of scroll per frame
  const intervalSpeed = 16; // Time between scroll frames (in ms)

  // Function to clone the slides for infinite scrolling
  function cloneSlides() {
    slides.forEach(slide => {
      const clone = slide.cloneNode(true);
      sliderTrack.appendChild(clone); // Clone the slides and append them
    });
  }

  // Ensure pixel-perfect scrolling to avoid gaps
  function roundToWholePixel(value) {
    return Math.floor(value); // Round to the nearest whole pixel to avoid subpixel issues
  }

  // Automatic sliding function using transform
  function startAutoSlide() {
    autoSlideInterval = setInterval(() => {
      currentTranslateX -= scrollSpeed; // Move the slider to the left

      // Check if we need to reset the translation (when we reach half the scroll width)
      if (Math.abs(currentTranslateX) >= sliderTrack.scrollWidth / 2) {
        currentTranslateX = 0; // Reset to the beginning
      }

      // Apply the transformation with pixel rounding to avoid gaps
      sliderTrack.style.transform = `translateX(${roundToWholePixel(currentTranslateX)}px)`;
    }, intervalSpeed); // Adjust the interval frequency for smoother movement
  }

  function stopAutoSlide() {
    clearInterval(autoSlideInterval);
  }

  // Clone slides for infinite effect
  cloneSlides();

  // Start automatic sliding when the page loads
  startAutoSlide();

  // Stop auto-slide on hover
  slider.addEventListener('mouseenter', stopAutoSlide);

  // Resume auto-slide when hover ends
  slider.addEventListener('mouseleave', startAutoSlide);
});
